import {
    AsyncAnalyticsDataDto,
} from '../../dtos';

import {Action} from '../actions/analyticsActions';
import {ActionType} from '../actionTypes';


const initialState = {
    analyticsData: {
        todaysImpressions: null,
        todaysConversions: null,
        totalImpressions: null,
        totalConversions: null
    },
    loadingExcel: false,
    loading: false,
    error: null,
    type: null,
}

const reducer = (state: AsyncAnalyticsDataDto = initialState, action: Action) => {

    switch(action.type)
    {
        //
        case ActionType.GET_ANALYTICS_DATA_FOR_FLYER_START:
            return { ...state, error: null, loading: true, type: action.type };

        case ActionType.GET_ANALYTICS_DATA_FOR_FLYER_SUCCESS:
            return {
                ...state,
                analyticsData: action.payload,
                error: null,
                loading: false,
                type: action.type
            };
        case ActionType.GET_ANALYTICS_DATA_FOR_FLYER_COMPLETE:
            return { ... state, error: null, loading: false, type: action.type};
        case ActionType.GET_ANALYTICS_DATA_FOR_FLYER_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };
        case ActionType.DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_START:
            return { ...state, loadingExcel: true, error: null, type: action.type};
        case ActionType.DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_SUCCESS:
            return {...state, loadingExcel: false, error: null, type: action.type};
        case ActionType.DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_COMPLETE:
            return { ... state, loadingExcel: false, error: null, type: action.type};
        case ActionType.DOWNLOAD_ANALYTICS_DATA_FOR_FLYER_EXCEL_ERROR:
            return { ...state, loadingExcel: false, error: action.payload, type: action.type };

        default:
            return state;
    }
}

export default reducer;